import React from "react";
import style from "./../style.module.css";
import { Input, Button, Textarea } from "@my-scoot/component-library-legacy";
import { is_empty, validURL } from "utils/validations";
import { api, dataProvider } from "data";
import constants from "constants/constants";
import { useNotifications } from "utils/hooks";
import { refreshIframe, validateData } from "./CreatorMiscellaneousData/Utils";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import classnames from "classnames";
import {
  DEFAULT_IMAGE_PARAMS,
  MiscellaneousConfig,
} from "ui/pages/TemplatePreview/constants";
import useSetMissceleneous from "./common/useSetMissceleneous";
import { handleErrors } from "./common/validator";
import useTemplatePreview from "ui/pages/TemplatePreview/hooks/useTemplatePreview";
import { isRequestSuccessful } from "utils/Utils";
import {
  TEMPLATE_KEYS,
  SIDEBAR_SECTIONS,
  SIDEBAR_KEYS,
  SECTIONKEY_TO_MISC_KEY,
} from "ui/pages/TemplatePreview/constants";
import { getBackgroundImageParams } from "ui/pages/TemplatePreview/utils";
import { BackgroundImage as UnlockBgImg } from "./Unlock/IntroVideo/BackgroundImage";
import { creator_miscellaneous_data_types } from "features/Common/modules/CreatorData/CreatorData.constants";
import SectionVisibilityToggle from "./hideShow";
import { handleVisibilityToggle } from "../utils";
import useVisibilityMutations from "../useVisibilityMutations.hook";

const formData = {
  heading: {
    key: "heading",
    label: "Heading",
  },
  description: {
    key: "description",
    label: "Description",
  },
  mediaLink: {
    key: "mediaLink",
    label: "Intro video link (eg: Youtube video)",
  },
};

export const IntroVideo = (props) => {
  const { state, disableAllEdits } = props;

  const { notify } = useNotifications();
  const { miscellaneous_data, fetchMiscellaneousData, set_miscellaneous_data } =
    React.useContext(WebpageCreationContext);
  const { pushNotif } = useTemplatePreview();
  const [section_name, set_section_name] = React.useState("Know us better");
  const [uuid, set_uuid] = React.useState(null);
  const [processing, set_processing] = React.useState(false);
  const [data, set_data] = React.useState({});
  const [error_object, set_error_object] = React.useState({});
  const [visible, set_visible] = React.useState(true);

  // Mutations for visibility toggle
  const { createMutation, updateMutation } = useVisibilityMutations();

  React.useEffect(() => {
    assignData();
  }, []);

  React.useEffect(() => {
    // Taking 0th element of miscellaneous_data - introVideo as latest to update
    if (!is_empty(miscellaneous_data?.introVideo)) {
      const [videoData] = miscellaneous_data.introVideo;
      if (videoData?.uuid) {
        set_uuid(videoData?.uuid);
      }
    }
  }, [miscellaneous_data]);

  useSetMissceleneous({
    listeners: [data, section_name, uuid, visible],
    data: {
      ...miscellaneous_data,
      introVideo: [
        {
          ...(uuid && {
            uuid,
          }),
          data: {
            section_name,
            visible,
            data: {
              intro_video_bg: data?.intro_video_bg,
              description: data?.description,
              heading: data?.heading,
              mediaLink: data?.mediaLink,
            },
          },
        },
      ],
    },
    updateHandler: {
      introVideo: {
        handleSave: () => handleSave(),
      },
    },
  });

  const assignData = () => {
    try {
      if (is_empty(miscellaneous_data?.introVideo)) return;
      let temp = miscellaneous_data?.introVideo[0];
      set_data(temp?.data?.data);
      set_section_name(temp?.data?.section_name);
      set_uuid(temp?.uuid);

      // SAFETY NET: default visible = true
      set_visible(temp?.data?.visible ?? true);
    } catch (err) {
      notify(
        err?.body?.message ? err?.body?.message : constants.error_message,
        "error"
      );
    }
  };

  const handleSave = async () => {
    try {
      if (processing) return;
      set_processing(true);

      const newData = { heading: data?.heading };
      const error_obj = validateData(newData, "Required");
      if (!is_empty(error_obj) || error_object?.mediaLink) {
        set_error_object(Object.assign(error_object, error_obj));
        return notify("Invalid form values", "error");
      }

      let payload, api_resource;
      let temp = data;
      if (temp?.draft) {
        delete temp.draft;
      }
      // Taking 0th element of miscellaneous_data - introVideo as latest to update
      let api_uuid = uuid;
      if (!is_empty(miscellaneous_data?.introVideo)) {
        const [videoData] = miscellaneous_data.introVideo;
        if (videoData?.uuid) {
          api_uuid = videoData?.uuid;
        }
      }
      if (is_empty(api_uuid)) {
        api_resource = api.creator_miscellaneous_data.create;
        payload = {
          type: creator_miscellaneous_data_types.INTRO_VIDEO,
          data: { section_name, visible, data: temp },
        };
      } else {
        api_resource = api.creator_miscellaneous_data.update;
        payload = {
          uuid: api_uuid,
          updated_values: {
            data: { section_name, visible, data: temp },
          },
        };
      }
      const status = await dataProvider.custom_request(
        api_resource,
        "POST",
        payload
      );
      if (isRequestSuccessful(status.status)) {
        refreshIframe();
        set_data({ ...temp });
        set_error_object({});

        await fetchMiscellaneousData({
          type: creator_miscellaneous_data_types.INTRO_VIDEO,
        });
      }
      pushNotif(status?.message);
    } catch (err) {
      notify(
        err?.body?.message ? err?.body?.message : constants.error_message,
        "error"
      );
    } finally {
      set_processing(false);
    }
  };

  const updateData = (value, key) => {
    let temp = data;
    temp[key] = value;
    set_data({ ...temp });
  };

  const imageParams = getBackgroundImageParams(
    state,
    TEMPLATE_KEYS.UNLOCK,
    DEFAULT_IMAGE_PARAMS[TEMPLATE_KEYS.UNLOCK].width
  );

  const onToggleVisibility = () =>
    handleVisibilityToggle({
      currentVisible: visible,
      setVisible: set_visible,
      miscellaneousData: miscellaneous_data,
      sectionKey: SECTIONKEY_TO_MISC_KEY[SIDEBAR_KEYS.INTRO_VIDEO],
      sectionType: creator_miscellaneous_data_types.INTRO_VIDEO,
      defaultSectionName: SIDEBAR_SECTIONS[SIDEBAR_KEYS.INTRO_VIDEO].title,
      fetchMiscellaneousData,
      set_miscellaneous_data,
      createMutation: createMutation,
      updateMutation: updateMutation,
    });

  return (
    <div>
      <SectionVisibilityToggle
        visible={visible}
        disabled={disableAllEdits}
        onToggle={onToggleVisibility}
      />

      <UnlockBgImg
        data={data}
        set_data={set_data}
        slug_value={state?.template?.slug}
        imageParams={imageParams}
        disableAllEdits={disableAllEdits}
      />
      <div className={classnames(style.label)}>
        What would you like to call this section?
      </div>

      <div className={`mt-3 mb-1`}>
        <Input
          fullWidth
          error={error_object?.section_name}
          helperText={error_object?.section_name}
          value={section_name}
          className={style.placeholder}
          inputProps={{
            maxLength: MiscellaneousConfig.maxTitleLength,
          }}
          onChange={(e) => {
            let value = e.target.value;

            const error = handleErrors(
              error_object,
              "section_name",
              value,
              MiscellaneousConfig.maxTitleLength,
              false
            );
            set_error_object(error);
            set_section_name(value);
          }}
          disabled={disableAllEdits}
        />
      </div>

      <div className={classnames(style.label, style.required, "mt-3", "mb-1")}>
        {formData.heading.label}
      </div>
      <Input
        error={error_object?.heading}
        helperText={error_object?.heading || null}
        placeholder="Eg: Explore How can I help you"
        className={style.placeholder}
        value={data?.heading}
        fullWidth
        inputProps={{
          maxLength: MiscellaneousConfig.maxTitleLength,
        }}
        onChange={(e) => {
          let value = e.target.value;

          const error = handleErrors(
            error_object,
            formData.heading.key,
            value,
            MiscellaneousConfig.maxTitleLength
          );
          set_error_object(error);
          updateData(value, formData.heading.key);
        }}
      />

      <div className={classnames(style.label, "mt-3", "mb-1")}>
        {formData.description.label}
      </div>
      <Textarea
        error={error_object?.description}
        helperText={error_object?.description || null}
        placeholder="Tip: use this space to describe this section"
        value={data?.description}
        rows="4"
        customClasses={{
          wrapper: style.placeholder,
        }}
        maxLength={MiscellaneousConfig.maxDescLength}
        onChange={(e) => {
          let value = e.target.value;

          const error = handleErrors(
            error_object,
            formData.description.key,
            value,
            MiscellaneousConfig.maxDescLength,
            false
          );
          set_error_object(error);
          updateData(value, formData.description.key);
        }}
        minWidth="100%"
      />

      <div className={classnames(style.label, "mt-3", "mb-1")}>
        {formData.mediaLink.label}
      </div>
      <Input
        error={error_object?.mediaLink}
        helperText={error_object?.mediaLink ? "Invalid URL" : null}
        placeholder="Paste video link here"
        className={style.placeholder}
        value={data?.mediaLink}
        fullWidth
        onChange={(e) => {
          let value = e.target.value;

          if (value && !validURL(value)) {
            set_error_object({ ...error_object, mediaLink: true });
          } else {
            set_error_object({ ...error_object, mediaLink: false });
          }
          updateData(value, formData.mediaLink.key);
        }}
      />

      <div className={classnames(style.linkContainer, "mt-2")}>
        Not sure where to start? Learn: &nbsp;
        <a
          className={style.link}
          href="https://support.google.com/youtube/answer/57407?co=GENIE.Platform%3DDesktop&hl=en"
          target="_blank"
          rel="noopener noreferrer"
        >
          How to upload?
        </a>
      </div>

      <Button
        variant="contained"
        color="primary"
        disableElevation
        disabled={processing || disableAllEdits}
        loading={processing}
        onClick={handleSave}
        className={classnames(style.nextSectionPrompt, "mt-4 mb-3")}
      >
        Save & next
      </Button>
    </div>
  );
};
